import { useMemo } from "react";
import { useQuery } from "react-query";
import { downloadFile } from "../../api/file-download";

export default function useFileDownload(fileUrl) {
  const {
    data: fileBlob,
    refetch: fileDownload,
    isFetching: isFetchingFile,
    isRefetching: isRefetchingFile,
    isFetched: isFetchedFile,
    error: errorFile,
    isError: isErrorFile,
    errorMessage: errorMessageFile,
  } = useQuery(["download-file", fileUrl], () => downloadFile(fileUrl), {
    enabled: false,
  });

  const formattedResult = useMemo(
    () => ({
      fileBlob,
      fileDownload,
      isFetchingFile,
      isRefetchingFile,
      isFetchedFile,
      errorFile,
      isErrorFile,
      errorMessageFile,
    }),
    [fileBlob, fileDownload, isFetchingFile, isRefetchingFile, isFetchedFile, errorFile, isErrorFile, errorMessageFile]
  );

  return formattedResult;
}
